module.exports = __webpack_public_path__ + "img/52002765_L.51441082.png";